import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import SearchBox from '../../components/common/Search/SearchBox';
import Filter from '../../components/common/Filter/Filter';
import GroupBy from '../../components/common/GroupBy/GroupBy';
import Sort from '../../components/common/Sort/Sort';
import TotalCount from '../../components/common/TotalCount/TotalCount';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import AddButton from '../../components/common/AddButton/AddButton';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import '../../pages/Faq/Faqs.css';
import { baseurl } from '../../api';
import ExportLabel from '../../components/common/ExportLabel/Export';
import { useCheckboxClick } from '../../checkboxclick';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import useRefreshStore from '../../store/useRefreshStore';
import OrgUserPopup from '../../components/Popup/Individual Popup/OrgUserPopUp';
import { archiveOrgUser, archiveSelectedOrgUsers, deleteOrgUser, editOrgUserAccounts } from '../../services/Subscriptions/OrgUserService';
const pageKey = "useraccounts"

const UserAccounts = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [mode, setMode] = useState([]);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isPopupOpen, setIsNewPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); 
  const navigate = useNavigate();
  const [popupError, setPopupError] = useState('');
  const [items, setItems] = useState([]);
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const searchCategories = ['Name','Company','Mobile','Email'];
  const filterOptions = ['Default', 'Archived','Unarchived'];
  const groupbyOptions = ['Default','Company'];
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [groupedItems, setGroupedItems] = useState({});
  const [expandedGroups, setExpandedGroups] = useState(new Set());
  const [selectedGroupByOption, setSelectedGroupByOption] = useState('Default');
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["User Accounts"] || 0;

  const fetchUseraccounts = async (id = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}accounts/users/organizational/?id=${id}`);
        
        if (response?.data?.response_code === 1) {
          setSelectedItem(response.data.data);
        } else {
          console.error("No data found for the selected user account.");
        }
      } else {
        const params = {
          search: searchParams.term,
          search_argument: searchParams.argument,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
          group_by: selectedGroupByOption.toLowerCase(),
        };
  
        const response = await authenticatedAxios.get(`${baseurl}accounts/users/organizational/`, { params });
  
        if (response?.data?.response_code === 1) {
          setItems(response.data.data); 
          if (selectedGroupByOption !== 'Default') {
            groupItems(response.data.data, selectedGroupByOption);
          }
        } else {
          console.error("Unexpected response code or no data found for user accounts.");
        }
      }
    } catch (error) {
      // Handle permission denied by redirecting to permission-denied page
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied");
      } else {
        console.error('Error fetching user accounts:', error);
      }
    }
  };
  

  const groupItems = (data, groupBy) => {
    const grouped = data.reduce((acc, item) => {
      let key;
      switch (groupBy.toLowerCase()) {
        case 'company':
          key = item.organization.name;
          break;
        default:
          key = 'default';
      }
      
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
    
    setGroupedItems(grouped);
  };
 
  useEffect(() => {
    fetchUseraccounts();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedSortOption,selectedGroupByOption]);

  useEffect(() => {
    fetchUseraccounts();
  }, [refreshKey]);

  const handleGroupBySelect = (option) => {
    setSelectedGroupByOption(option);
  };


  const toggleGroup = (groupName) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(groupName)) {
        newSet.delete(groupName);
      } else {
        newSet.add(groupName);
      }
      return newSet;
    });
  };

  const renderGroupedTable = () => {
    if (selectedGroupByOption === 'Default') {
      return (
        <tbody className='common-table-tbody'>
          {renderTableRows(items)}
        </tbody>
      );
    }


    return (
      <tbody className='common-table-tbody'>
        {Object.entries(groupedItems).map(([groupName, groupSubscriptions]) => (
          <React.Fragment key={groupName}>
            <tr className="group-header-row">
              <td colSpan="6" className="group-header">
                <div 
                  className="group-header-content"
                  onClick={() => toggleGroup(groupName)}
                >
                  <svg 
                    className={`expand-item-icon ${expandedGroups.has(groupName) ? 'rotated' : ''}`} 
                    width="7" 
                    height="13" 
                    viewBox="0 0 7 13" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7 6.5L0.25 12.9952L0.250001 0.00480908L7 6.5Z" fill="#424242"/>
                  </svg>
                  <span className="group-name common-text fts-15 blue">{groupName}</span>
                  <span className="group-count common-text fts-15 blue">({groupSubscriptions.length})</span>
                </div>
              </td>
            </tr>
            {expandedGroups.has(groupName) && renderTableRows(groupSubscriptions)}
          </React.Fragment>
        ))}
      </tbody>
    );
  };
  const renderTableRows = (useraccounts) => {
      return useraccounts.length > 0 ? (
        useraccounts.map((useraccount) => (
          <tr key={useraccount.id} className={useraccount.is_archived ? 'archived-item' : ''}>
                <td className='d-flex ai-center'>
                  <div className='d-flex ai-center'>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(useraccount.id)}
                    onChange={() => handleChildCheckboxChange(useraccount.id)}
                  />
                  </div>
                  <span  onClick={() => handleUserDetailClick(useraccount.id)} className="blue company-name">{useraccount.full_name}</span>
                </td>
                <td className='blue cr-pointer' onClick={() => handleDetailClick(useraccount.organization?.id)}>
                  {useraccount.organization?.name}
                </td>
                <td className='txt-lc'>{useraccount.email}</td>
                <td>{useraccount.country_code?.country_code} {useraccount.phone}</td>
                <td>{useraccount.role?.name}</td>

                <td className="actions common-action">
                  <EditIcon onClick={() => handleEditClick(useraccount)} />
                  <ArchiveIcon onClick={() => handleArchiveClick(useraccount)} isArchived={useraccount.is_archived}/>
                  <DeleteIcon onClick={() => handleDeleteClick(useraccount)} />
                </td> 
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="6">No users found.</td>
        </tr>
      );
    };


  // const AddUserAccounts = async (formValues) => {
  //   try {
  //     // Create a FormData object to handle file upload
  //     const formData = new FormData();
      
  //     // Add all regular form fields to FormData
  //     Object.keys(formValues).forEach(key => {
  //       // Special handling for nested objects
  //       if (key === 'organization' || key === 'role' || key === 'preferred_language') {
  //         formData.append(key, formValues[key].value || formValues[key]);
  //       } 
  //       // Special handling for file upload
  //       else if (key === 'country_flag' && formValues[key] instanceof File) {
  //         formData.append('profile_pic', formValues[key]); // Note: Backend expects 'profile_pic'
  //       }
  //       // Handle all other fields
  //       else if (key !== 'country_flag') {
  //         formData.append(key, formValues[key]);
  //       }
  //     });
  
  //     // Update the axios request to handle FormData
  //     const response = await authenticatedAxios.post(
  //       `${baseurl}accounts/users/organizational/`, 
  //       formData,
  //       {
  //         headers: {
  //           'Content-Type': 'multipart/form-data',
  //         },
  //       }
  //     );
  
  //     if (response.data.response_code === 1) {
  //       fetchUseraccounts();
  //       closePopups();
  //     } else {
  //       console.error('Unexpected response code:', response.data.response_code);
  //     }
  //   } catch (error) {
  //     console.error('Error updating user accounts:', error);
  //   }
  // };


  const AddUserAccounts = async (formValues) => {
    try {
      const formData = new FormData();
  
      Object.keys(formValues).forEach(key => {
        if (key === 'organization' || key === 'role' || key === 'preferred_language') {
          formData.append(key, formValues[key].value || formValues[key]);
        } else if (key === 'country_flag' && formValues[key] instanceof File) {
          formData.append('profile_pic', formValues[key]);
        } else if (key !== 'country_flag') {
          formData.append(key, formValues[key]);
        }
      });
  
      const response = await authenticatedAxios.post(
        `${baseurl}accounts/users/organizational/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      if (response.data.response_code === 1) {
        fetchUseraccounts();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Failed to add user account.');
      }
    } catch (error) {
      setPopupError('Error adding user account. Please try again.');
    }
  };
  

  const handleEditUser = async (formValues) => {
    const result = await editOrgUserAccounts(formValues, selectedItem.id);
    if (result.success) {
      fetchUseraccounts();
      closePopups();
    } else {
      setPopupError(result.message);
    }
  };
  

    const handleArchiveSelectedItems = async () => {
    const result = await archiveSelectedOrgUsers(selectedItems);
    
    if (result.success) {
      fetchUseraccounts();
      resetCheckboxState(); 
      closePopups();
    } else {
      // Handle error case - could show user-friendly error message
      // console.error('Failed to archive selected organizational users:', result.error);
    }
  };

  const handleArchive = async () => {
    const result = await archiveOrgUser(selectedItem.id);
    
    if (result.success) {
      await fetchUseraccounts(); // Fetch updated user accounts list
      closePopups(); // Close the archive popup
    } else {
      // Handle error case - could show user-friendly error message
      // console.error('Failed to archive organizational user:', result.error);
    }
  };

  // const handleDelete = async () => {
  //   try {
  //     const response = await authenticatedAxios.delete(
  //       `${baseurl}accounts/users/organizational/?id=${selectedItem.id}`
  //     );
  
  //     if (response.status >= 200 && response.status < 300) {
  //       setIsDeletePopupOpen(false); 
  //       fetchUseraccounts(); 
  //       return;
  //     }
  //     throw new Error(`Unexpected status code: ${response.status}`);
  //   } catch (error) {
  //     // console.error('Error deleting plan:', error);
  //   }
  // };



  const handleDelete = async () => {
    const result = await deleteOrgUser(selectedItem.id);
    
    if (result.success) {
      closePopups();
      fetchUseraccounts(); 
    } else {
      // Handle error case - could show user-friendly error message
    }
  };

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };

  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
  };

  const handleSearchSelect = (searchCategory,searchTerm) => {
    setSearchParams({
      term: searchTerm,                   
      argument: searchCategory.toLowerCase(), 
    });
  };
  
  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item)
    setIsNewPopupOpen(true);
    setMode("edit")

   };

  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const handleNewClick = () => {
    setSelectedItem([]);
    setIsNewPopupOpen(true);
    setMode("add")
  };



  const handleUserDetailClick = (userId) => {
    navigate(`/user-detail/organizational/${userId}`);
  };
    const handleDetailClick = (organizationId) => {
      if (organizationId) {
        navigate(`/customer-detail/${organizationId}`);
      } else {
        console.error('Organization ID is undefined');
      }
    };
    

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];


  const handleExportComplete = () => {
    resetCheckboxState();
  };


  const closePopups = () => {
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setIsDeletePopupOpen(false);
    setSelectedItem([])
    setPopupError('');
  };

  return (
    <div className='whole-container'>  
      <div className='top-heading'>
        <PageHeader pageName="Subscription /" nestedpageName="User Accounts"  linkTo="" /> 
        <div className='export-container'>
            <ArchiveSelectedItem
              selectedItems={selectedItems}
              items={items}
              onArchiveSelected={handleArchiveSelectedItems}
            />
            <ExportLabel
              exportUrl={`${baseurl}accounts/organizational/users/export/`}
              selectedIds={selectedItems}
              onExportComplete={handleExportComplete}
            />
        </div>
      </div>     
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>User Accounts</h1>
        </div>
        <div className='pagename-right-container'>
          <TotalCount TotalName="Total User Accounts" TotalCount={items.length} />
          <AddButton onClick={handleNewClick} />
          <SearchBox categories={searchCategories} onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <GroupBy 
            options={groupbyOptions} 
            selectedOption={selectedGroupByOption}
            onSelect={handleGroupBySelect}
          />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption}/>
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
              <tr className='common-table-thead-tr'>
                <th className='w-20'>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />Name
                </th>
                <th className='w-20'>Company</th>
                <th className='w-20'>Email</th>
                <th className='w-15'>Mobile</th>
                <th className='w-15'>Role</th>
                <th className='w-10'>Actions</th>
              </tr>
          </thead>
          {renderGroupedTable()}
        </table>
      </div>


      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.full_name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      {/* <AddPopup 
        isOpen={isPopupOpen}
        title="New User"
        buttonName='Add User'
        fields={addPopupFields}
        onSave={AddUserAccounts}
        onClose={closePopups}
        popupErrorMessage={popupError}
      /> */}
      <OrgUserPopup 
        isOpen={isPopupOpen}
        mode={mode}
        defaultValue={selectedItem}
        onSave={mode === 'add' ? AddUserAccounts : handleEditUser}
        buttonName={mode === 'add' ? 'Add User' : 'Save'}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />
      {/* <EditPopup 
        isOpen={isEditPopupOpen}
        title="Edit User"
        fields={editPopupFields}
        onSave={EditUserAccounts}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />  */}
      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete User"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      /> 
    </div>
  );
};

export default UserAccounts;
